import cx from "classnames"
import * as React from "react"
import ChevronIcon from "../images/svg/chevron.svg"

const SliderControls = ({
  items,
  Slide,
  sliderStyle,
  double = true,
  arrowClass,
  arrows = true,
}) => {
  const slides = double ? [...items, ...items] : items
  const [currentSlide, setCurrentSlide] = React.useState(1)

  const toggleNextSlide = () => {
    setCurrentSlide((currentSlide + 1) % items.length)
  }

  const togglePreviousSlide = () => {
    setCurrentSlide(currentSlide - 1 < 0 ? items.length - 1 : currentSlide - 1)
  }

  React.useEffect(() => {
    const nextIndex = (currentSlide + 1) % items.length
    const id = setTimeout(() => setCurrentSlide(nextIndex), 3000) // Change image every 3 seconds

    return () => clearTimeout(id)
  }, [currentSlide, items.length])

  return (
    <div className={arrows ? "container" : "container-wide"}>
      <div className="w-full flex">
        {arrows && <div
          className={cx(
            arrowClass,
            "tablet:w-14 flex items-center justify-start shrink-0"
          )}
        >
          <button
            aria-label="Show previous slide"
            type="button"
            className="w-full h-full text-grey-500"
            onClick={togglePreviousSlide}
          >
            <ChevronIcon />
          </button>
        </div>}

        <div className="flex-1 relative overflow-hidden">
          <div style={sliderStyle} className="w-full grid relative">
            {slides.map((__item, index) => (
              <Slide
                key={index}
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                index={index}
              />
            ))}
          </div>
        </div>
        {arrows && <div
          className={cx(arrowClass, "tablet:w-14 flex items-center shrink-0")}
        >
          <button
            type="button"
            aria-label="Show next slide"
            className="w-full h-full flex items-center justify-end text-grey-500"
            onClick={toggleNextSlide}
          >
            <ChevronIcon className="rotate-180" />
          </button>
        </div>}
      </div>
      <div className="mb-14 mt-8 space-x-2 mx-auto flex items-center justify-center">
        {items.map((__item, index) => (
          <button
            key={`slider-btn-${index + 1}`}
            type="button"
            aria-label={`Go to slide #${index + 1}`}
            onClick={() => setCurrentSlide(index)}
            className={cx(
              arrows ? currentSlide === index ? "bg-black" : "bg-white hover:bg-black" : currentSlide === index ? "bg-white" : "bg-transparent" ,
              arrows ? "border-black" : "border-white",
              "w-2.5 h-2.5 rounded-full border "
            )}
          />
        ))}
      </div>
    </div>
  )
}

export default SliderControls
